import { Component, OnInit, Input } from '@angular/core'

@Component({
    selector: 'col-logo-bandeira',
    templateUrl: './logo-bandeira.component.html'
})
export class LogoBandeiraComponent implements OnInit {
    @Input() bandeira: string

    imagePath: string

    imageAlt: string

    constructor() {}

    ngOnInit() {
        this.imageAlt = this.bandeira
        this.imagePath = `https://cdn.alterdata.com.br/pack/packup/Content/images/cartoes/${this.getFileName()}`
    }

    private getFileName() {
        const bandeira = this.bandeira.toLowerCase()

        switch (bandeira) {
            case 'banescard':
                return 'estabelecimento_banescard.png'
            case 'ipiranga':
                return 'estabelecimento_rede_ipiranga.png'
            case 'sodexo alimentação':
                return 'estabelecimento_sodexo_alimentacao.png'
            case 'sodexo combustível':
                return 'estabelecimento_sodexo_combustivel.png'
            case 'sodexo cheque refeição':
                return 'estabelecimento_sodexo_cheque_refeicao.png'
            case 'sodexo refeição':
                return 'estabelecimento_sodexo_refeicao.png'

            default:
                const id = bandeira.trim().replace(/ /g, '_')

                return `estabelecimento_${id}.png`
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/common/logo-bandeira/logo-bandeira.component.ts